import { c as _c } from "react/compiler-runtime";
import { IconButton } from "@/components/ui/IconButton";
import { Input } from "@/components/ui/Input";
import { SearchIcon, XIcon } from "lucide-react";
import * as React from "react";
import { useHotkeys } from "react-hotkeys-hook";
import cn from "twsx";
function useCombinedRefs(...t0) {
  const $ = _c(2);
  const refs = t0;
  let t1;
  if ($[0] !== refs) {
    t1 = element => {
      refs.forEach(currentRef => {
        if (!currentRef) {
          return;
        }
        if (typeof currentRef === "function") {
          currentRef(element);
        } else {
          (currentRef as React.MutableRefObject<T | null>).current = element;
        }
      });
    };
    $[0] = refs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export function SearchInput(t0) {
  const $ = _c(46);
  let className;
  let defaultValue;
  let onChange;
  let onKeyDown;
  let onSearch;
  let props;
  let ref;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      className,
      onSearch,
      onChange,
      onKeyDown,
      placeholder: t1,
      size: t2,
      defaultValue,
      value,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = defaultValue;
    $[3] = onChange;
    $[4] = onKeyDown;
    $[5] = onSearch;
    $[6] = props;
    $[7] = ref;
    $[8] = t1;
    $[9] = t2;
    $[10] = value;
  } else {
    className = $[1];
    defaultValue = $[2];
    onChange = $[3];
    onKeyDown = $[4];
    onSearch = $[5];
    props = $[6];
    ref = $[7];
    t1 = $[8];
    t2 = $[9];
    value = $[10];
  }
  const placeholder = t1 === undefined ? "Search..." : t1;
  const size = t2 === undefined ? "md" : t2;
  const inputRef = React.useRef(null);
  const combinedRef = useCombinedRefs(inputRef, ref);
  let t3;
  if ($[11] !== defaultValue || $[12] !== value) {
    t3 = () => {
      if (typeof value === "string") {
        return value.length > 0;
      }
      if (typeof defaultValue === "string") {
        return defaultValue.length > 0;
      }
      return false;
    };
    $[11] = defaultValue;
    $[12] = value;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const [hasValue, setHasValue] = React.useState(t3);
  let t4;
  let t5;
  if ($[14] !== value) {
    t4 = () => {
      if (typeof value === "string") {
        setHasValue(value.length > 0);
      }
    };
    t5 = [value];
    $[14] = value;
    $[15] = t4;
    $[16] = t5;
  } else {
    t4 = $[15];
    t5 = $[16];
  }
  React.useEffect(t4, t5);
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = event => {
      event.preventDefault();
      inputRef.current?.focus();
    };
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  useHotkeys("/", t6);
  let t7;
  if ($[18] !== className) {
    t7 = cn("min-w-0 max-w-full shrink max-md:grow max-md:basis-0", className);
    $[18] = className;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SearchIcon aria-hidden="true" />;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = !hasValue && "invisible";
  let t10;
  if ($[21] !== t9) {
    t10 = cn("-mr-2", t9);
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== onSearch) {
    t11 = event_1 => {
      event_1.preventDefault();
      event_1.stopPropagation();
      onSearch("");
      if (inputRef.current) {
        inputRef.current.value = "";
        inputRef.current.focus();
      }
      setHasValue(false);
    };
    $[23] = onSearch;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <XIcon />;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== props.disabled || $[27] !== t10 || $[28] !== t11) {
    t13 = <IconButton label="Clear search" size={24} type="button" className={t10} disabled={props.disabled} onMouseDown={_temp} onClick={t11}>{t12}</IconButton>;
    $[26] = props.disabled;
    $[27] = t10;
    $[28] = t11;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== onChange) {
    t14 = event_2 => {
      setHasValue(event_2.target.value.length > 0);
      onChange?.(event_2);
    };
    $[30] = onChange;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== onKeyDown || $[33] !== onSearch) {
    t15 = event_3 => {
      onKeyDown?.(event_3);
      if (!event_3.isDefaultPrevented() && event_3.key === "Enter") {
        onSearch(event_3.currentTarget.value);
      }
    };
    $[32] = onKeyDown;
    $[33] = onSearch;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== combinedRef || $[36] !== defaultValue || $[37] !== placeholder || $[38] !== props || $[39] !== size || $[40] !== t13 || $[41] !== t14 || $[42] !== t15 || $[43] !== t7 || $[44] !== value) {
    t16 = <Input ref={combinedRef} type="text" role="searchbox" enterKeyHint="search" size={size} className={t7} prefixIcon={t8} suffixIcon={t13} defaultValue={defaultValue} value={value} placeholder={placeholder} onChange={t14} onKeyDown={t15} {...props} />;
    $[35] = combinedRef;
    $[36] = defaultValue;
    $[37] = placeholder;
    $[38] = props;
    $[39] = size;
    $[40] = t13;
    $[41] = t14;
    $[42] = t15;
    $[43] = t7;
    $[44] = value;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  return t16;
}
function _temp(event_0) {
  event_0.preventDefault();
}
SearchInput.displayName = "SearchInput";